import { on } from 'delegated-events';
import showPopup from './modals';
import { isVisible, findSiblings, slideToggle, slideUp, slideDown } from './utils/utils';

export default function () {


    on('change', '[data-target-to-show]', function () {
        let toShow = document.querySelector(`#${this.dataset.targetToShow}`);
        if (!toShow) return;

        slideToggle(toShow);
    });



    // FILTER
    const filter = document.getElementById('filter');
    const sorter = document.querySelector('[data-dropdown-type="sort"]');

    if (filter) {
        function createFilterSorter() {
            const filterSorter = sorter.cloneNode(true);
            sorter.remove();
            filter.querySelector('.close-filter').insertAdjacentElement('afterend', filterSorter);

            filterSorter.querySelector('.dropdown-button').addEventListener('click', function () {
                filterSorter.classList.toggle('show-dropdown-rwd');
            });

            on('click', '#filter .dropdown-listing > span', function () {
                filterSorter.classList.remove('show-dropdown-rwd');
            });

            document.addEventListener('click', function (event) {
                const element = filterSorter;

                if (!element.contains(event.target) && isVisible(element)) {
                    element.classList.remove('show-dropdown-rwd');
                }
            });
        }

        const body = document.body;
        const isCanvasFilter = document.body.hasAttribute('data-canvas-filter');

        if (isCanvasFilter) { // IF CANVAS FILTER
            on('click', '.filter-trigger', function () {
                if (window.innerWidth < 1280) {
                    body.classList.add('overlay-visible');
                    body.classList.add('show-filter');
                    filter.style.display = 'block';

                    if (!filter.querySelector('.dropdown-picker[data-dropdown-type="sort"]') && sorter) createFilterSorter();

                } else {
                    document.getElementById('container').classList.toggle('show-side-filter');
                }
            });

            document.addEventListener('mouseup', function (e) {
                const isClickInside = filter.contains(e.target);

                if (!isClickInside) {
                    document.getElementById('container').classList.remove('show-side-filter');
                }
            });

        } else { // IF NOT CANVAS FILTER
            on('click', '.filter-trigger', function () {
                if (window.innerWidth < 1280) {
                    body.classList.add('overlay-visible');
                    body.classList.add('show-filter');
                    filter.style.display = 'block';

                    if (!filter.querySelector('.dropdown-picker[data-dropdown-type="sort"]') && sorter) createFilterSorter();
                }
            });
        }

        document.addEventListener('mouseup', function (e) {
            const isClickInside = filter.contains(e.target);

            if (!isClickInside) {
                document.getElementById('container').classList.remove('show-side-filter');
            }
        });

        document.querySelector('.close-filter').addEventListener('click', function () {
            if (window.innerWidth < 1280) {
                body.classList.remove('overlay-visible');
                body.classList.remove('show-filter');
                filter.style.display = 'none';
            }
        });

        filter.querySelectorAll('.gs-filtr-container > strong').forEach(strong => {
            strong.addEventListener('click', function () {
                if (window.innerWidth < 1280) {
                    this.parentElement.classList.toggle('show-list');
                }
            });
        });

        filter.querySelector('.close-filter-bottom > span').addEventListener('click', function () {
            if (window.innerWidth < 1280) {
                body.classList.remove('overlay-visible');
                body.classList.remove('show-filter');
                filter.style.display = 'none';
            }
        });
    }

    // NEWSLETTER POPUP SUBMIT
    on('click', '.goshop-modal .newsletter-clauses-wrapper ~ button[type="submit"]', function (e) {
        const modal = document.querySelector('.basicLightbox');
        const standardNewsletter = modal.classList.contains('standard-newsletter');
        const checkboxes = modal.querySelectorAll('[type="checkbox"]:checked');

        if (checkboxes.length !== 1) {
            modal.querySelector('.newsletter-clauses-wrapper').classList.add('unchecked');
            e.preventDefault();
        } else if (!standardNewsletter && !modal.querySelector('.valid')) {
            const inputField = modal.querySelector('input[type="text"]');

            inputField.dispatchEvent(new Event('focusin', {
                bubbles: true,
                cancelable: true,
                type: 'focusin'
            }));
            inputField.parentElement.classList.add('invalid', 'filled');
        } else {
            window.currentModalInstance.close();

            const recaptchaItem = modal.querySelector('.g-recaptcha-response');

            const input = standardNewsletter
                ? document.querySelector('#newsletter input[type="text"]')
                : modal.querySelector('input[type="text"]');

            const payload = {
                email: input.value,
                recaptcha: recaptchaItem?.value || ''
            };

            fetch('/api/frontend/newsletter', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify(payload)
            }).then(response => response.json())
                .then(data => {
                    input.value = '';
                    showPopup({ body: data.message });
                }).catch(error => {
                    input.value = '';
                    console.log(error);
                });
        }
    });
}
